import React, { ReactElement, useEffect, useState } from 'react';
import { useParams, Redirect, Link } from 'react-router-dom';
import { API } from '../../../services/api';
import {
  SeminarInterface,
  SeminarState,
} from '../../../interfaces/SeminarInterface';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { formatDate } from '../../../utils/helper';
import { ParticipantInterface } from '../../../interfaces/ParticipantInterface';
import Participants from '../../../components/seminar/Participants';
import Loading from '../../../components/Loading';
import { PaginatedListInterface } from '../../../interfaces/PaginatedList';

export default (): ReactElement => {
  const [seminar, setSeminar] = useState<SeminarInterface>();
  const [participants, setParticipants] =
    useState<PaginatedListInterface<ParticipantInterface>>();
  const [redirect, setRedirect] = useState<boolean>(false);

  const MySwal = withReactContent(Swal);

  const { id }: any = useParams();

  const translateState = () => {
    switch (seminar?.state) {
      case SeminarState.ACTIVE:
        return 'Findet derzeit statt';
      case SeminarState.CREATED:
        return 'Erstellt';
      case SeminarState.SCHEDULED:
        return 'Geplant';
      case SeminarState.CANCELED:
        return 'Abgebrochen';
      case SeminarState.COMPLETED:
        return 'Beendet';
    }
  };

  useEffect(() => {
    (async () => {
      const result = await API.get(`host/seminars/${id}`);
      setSeminar(result);

      const participantsResult = await API.get(
        `host/seminars/${id}/participants`
      );
      setParticipants(participantsResult);
    })();
  }, []);

  const handleDelete = () => {
    MySwal.fire({
      title: 'Sicher, dass das Seminar endgültig gelöscht werden soll?',
      showCancelButton: true,
      confirmButtonText: 'Löschen',
    }).then(({ isConfirmed }) => {
      if (isConfirmed) {
        API.delete(`host/seminars/${id}`);
        setRedirect(true);
      }
    });
  };

  const handleReloadParticipants = async () => {
    const participantsResult = await API.get(
      `host/seminars/${id}/participants`
    );
    setParticipants(participantsResult);
  };

  if (redirect) return <Redirect to="/seminars/seminars" />;

  if (!seminar || !participants) return <Loading />;

  return (
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1>{seminar?.title}</h1>
          </div>
          <div
            className="col-sm-6"
            style={{
              textAlign: 'right',
            }}
          >
            <Link to={`/seminars/seminars/${seminar.id}/edit`}>
              <button type="button" className="btn btn-primary btn-sm">
                Bearbeiten
              </button>
            </Link>
            &nbsp; &nbsp; &nbsp;
            <button
              type="button"
              className="btn btn-danger btn-sm"
              onClick={handleDelete}
            >
              Löschen
            </button>
          </div>
        </div>
        <div>
          <strong>Beschreibung:</strong>
          <br />
          {seminar?.description}
          <br />
          <strong>Geplanter Start:</strong>{' '}
          {formatDate(seminar?.scheduledStart)} Uhr
          <br />
          <strong>Dauer in Minuten:</strong> {seminar?.length} Minuten
          <br />
          <strong>Status:</strong> {translateState()}
          <div>
            <Participants
              seminar={seminar}
              participants={participants}
              onChange={handleReloadParticipants}
            />
          </div>
        </div>
      </div>
    </section>
  );
};
